import { render, staticRenderFns } from "./DropdownMenuItemDivider.vue?vue&type=template&id=c45b3d40&"
import script from "./DropdownMenuItemDivider.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuItemDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
